import PostSneakPeek from './PostSneakPeek';

export default PostSneakPeek;
